export default __webpack_public_path__ + "static/media/aboutAnimation1.97641561.png";